import { TOGGLE_STAFFENQUIRYFORM_MODAL } from '../actions/staffEnquiryFormModal';

const initialState = {
  isOpen: false,
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case TOGGLE_STAFFENQUIRYFORM_MODAL:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
